import React, { Children } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { categories } from '../data/categories';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.05
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0
  }
};
export function CatalogPage() {
  return <main className="min-h-screen bg-slate-50" data-id="element-492">
      {/* Breadcrumbs */}
      <div className="bg-white border-b border-slate-100" data-id="element-493">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-494">
          <nav className="flex items-center gap-2 text-sm" data-id="element-495">
            <Link to="/" className="text-slate-500 hover:text-slate-700" data-id="element-496">
              Головна
            </Link>
            <span className="text-slate-300" data-id="element-497">/</span>
            <span className="text-slate-900 font-medium" data-id="element-498">Каталог</span>
          </nav>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-12" data-id="element-499">
        {/* Header */}
        <div className="mb-8 lg:mb-12" data-id="element-500">
          <h1 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-4" data-id="element-501">
            Каталог товарів
          </h1>
          <p className="text-lg text-slate-600 max-w-2xl" data-id="element-502">
            Все необхідне для басейну, сауни та відпочинку на воді. Оберіть
            категорію для перегляду товарів.
          </p>
        </div>

        {/* Categories Grid */}
        <motion.div initial="hidden" animate="visible" variants={containerVariants} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-503">
          {categories.map(category => <motion.div key={category.id} variants={itemVariants} data-id="element-504">
              <Link to={`/category/${category.slug}`} className="group block bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300" data-id="element-505">
                <div className="aspect-[16/10] overflow-hidden relative" data-id="element-506">
                  <img src={category.image} alt={category.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-507" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" data-id="element-508" />
                  <div className="absolute bottom-4 left-4 right-4" data-id="element-509">
                    <h2 className="text-xl font-bold text-white mb-1" data-id="element-510">
                      {category.name}
                    </h2>
                    <p className="text-sm text-white/80" data-id="element-511">
                      {category.productCount} товарів
                    </p>
                  </div>
                </div>
                <div className="p-5" data-id="element-512">
                  <p className="text-slate-600 text-sm mb-4 line-clamp-2" data-id="element-513">
                    {category.description}
                  </p>
                  <div className="flex items-center text-sky-600 font-medium text-sm group-hover:text-sky-700" data-id="element-514">
                    Переглянути товари
                    <ArrowRightIcon className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-515" />
                  </div>
                </div>
              </Link>
            </motion.div>)}
        </motion.div>
      </div>
    </main>;
}